export default __webpack_public_path__ + "static/media/logo-ui.03391a91.png";